<div class="min-w-30 min-h-30 flex flex-col items-center justify-center">
    <div class="p-6">
        <mat-progress-spinner [diameter]="50" [strokeWidth]="3" [mode]="'indeterminate'"></mat-progress-spinner>
    </div>
    <span class="italic text-gray-600 mt-4">aguarde...</span>
</div>
